module.exports = __webpack_public_path__ + "img/mask-group-1.7611865d.png";